export const environment = {
  production: false,
  stage: "dev",
  awsAccessKeyId: 'ENTER_ACCESS_KEY_ID',
  awsSecretAccessKey: 'ENTER_SECRET_ACCESS_KEY',
  cidaasRedirectUri: 'https://support-dev.reguard2.aws.rehau.cloud/callback'
};
